import { Injectable } from '@angular/core';
import {
  AbstractRestService,
  arrayOf,
  identity,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { productDetailsDto } from './stripe-product-DetailsDto';

@Injectable({ providedIn: 'root' })

export class ProductRestService extends AbstractRestService {
    constructor(settings: RestSettings) {
      super(settings);
    }
  
      create(product: productDetailsDto): Observable<productDetailsDto> {
        console.log('data' , product)
        return this.httpPost(`${this.bp}/stripe-products`, product, identity());
      }

      findAllAsDataSource(filter?: { showDeleted?: boolean }): SlicedDataSource<any> {
        return this.createSlicedDataSourceGet(`${this.bp}/stripe-products`, filter, identity(), arrayOf(identity()));
      }

      getById(productId: string): Observable<productDetailsDto> {
        return this.httpGet(`${this.bp}/stripe-products/${productId}`, identity());
      }

      update(product: productDetailsDto, force: boolean = false): Observable<productDetailsDto> {
        return this.httpPut(`${this.bp}/stripe-products/${product.id}?force=${force}`, product, identity());
      }

      deactivate(productId: string, force: boolean = false): Observable<any> {
        return this.httpPut(`${this.bp}/stripe-products/${productId}/deactivate?force=${force}`, null, identity());
      }

      findAll(filter?: { showDeleted?: boolean }): Observable<any[]> {
        return this.httpGet(`${this.bp}/stripe-products`, filter, identity(), arrayOf(identity()));
      }
  // Add other methods as needed (get, update, delete, etc.)
}
